// extracted by mini-css-extract-plugin
export default {"startupheading":"BlogStartup_startupheading__jpUqz"};